// extracted by mini-css-extract-plugin
export default {"lds-ellipsis":"Loader_lds-ellipsis__xmzTD","lds-ellipsis1":"Loader_lds-ellipsis1__mXfV2","lds-ellipsis2":"Loader_lds-ellipsis2__j7AtI","lds-ellipsis3":"Loader_lds-ellipsis3__n-A66"};